import SubscriptionArticleListResultModelBase from '../_generated/modelBases/subscription-article-list-result-model-base';

export default class SubscriptionArticleListResultModel extends SubscriptionArticleListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
